import React from 'react';
import Editor from '@monaco-editor/react';
import { Script } from '../services/api';
import './ScriptEditor.css';

interface ScriptEditorProps {
  script: Script;
  sessionId: string;
}

const ScriptEditor: React.FC<ScriptEditorProps> = ({ script }) => {
  // Use prop directly instead of state to ensure updates when script changes
  const code = script.code;

  // Script is read-only - no editing or saving functionality

  return (
    <div className="script-editor-container">
      <div className="editor-wrapper">
        <Editor
          height="500px"
          language="python"
          theme="vs-light"
          value={code}
          onChange={undefined} // No changes allowed
          options={{
            readOnly: true, // Make editor read-only
            minimap: { enabled: false },
            fontSize: 14,
            lineNumbers: 'on',
            wordWrap: 'on',
            automaticLayout: true,
            scrollBeyondLastLine: false,
            // Additional read-only styling
            renderLineHighlight: 'none',
            cursorStyle: 'line',
            cursorBlinking: 'solid'
          }}
        />
      </div>
      
      <div className="editor-footer">
        <p className="editor-hint">
          Review the generated Python script above. If there are issues, please ask the AI to regenerate or fix it.
        </p>
      </div>
    </div>
  );
};

export default ScriptEditor;